import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'Home',
            component: () =>
                import ('@/views/Home'),
        },
        {
            path: '/Home', //登录
            name: 'Home',
            component: () =>
                import ('@/views/Home'),
        },
        {
            path: '/contractTem', //模板
            name: 'contractTem',
            component: () =>
                import ('@/views/contractTem/contractTem0916'),
        },
        {
            path: '/contract', //合同
            name: 'contract',
            component: () =>
                import ('@/views/contract'),
        },
        // mySignature 电子签名
        {
            path: '/mySignature', //电子签名
            name: 'mySignature',
            component: () =>
                import ('@/views/signature/mySignature'),
        },
        {
            path: '/SignView', //签名新建
            name: 'SignView',
            component: () =>
                import ('@/views/signature/SignView'),
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js